







import Vue from 'vue';
import Component from 'vue-class-component';
import {forkJoin} from 'rxjs';
import {Prop} from 'vue-property-decorator';
import {GMAPS_MARKER_REGISTRY, MarkerService} from '@/utils/gmaps/gmaps.marker.service';
import {GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE} from '@/services/global-event-listener.service';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {SCRIPTLOADER_SERVICE_INSTANCE} from '@/services/scriptloader.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';

@Component({
  name: 'google-maps-template'
})
export default class GoogleMapsTemplate extends Vue {

  @Prop() typeSpecificSettings!: DisguiseDto.GMapsFieldSpecificSettings;

  circles: Array<{circle: google.maps.Circle, radius: number}> = [];
  initialZoom: number = 0;

  $refs!: {
    gmapsWrapper: HTMLDivElement
  };

  allMarkers: {
    [key: number]: {
      instance: google.maps.marker.AdvancedMarkerElement,
      config: DisguiseDto.GMapsMarker,
      service?: MarkerService<any>
    }
  } = {};
  mapInst: google.maps.Map | null = null;

  private registeredGlobalEventListenerNames: string[] = [];

  mounted() {
    const url = `/backend/api/v0/google/key`;
    HTTP_SERVICE_INSTANCE.getAxios().get(url).then((response: any) => {
      SCRIPTLOADER_SERVICE_INSTANCE.loadScript(
          `https://maps.googleapis.com/maps/api/js?key=${response.data.key}`
      ).then(() => {
        if (this.typeSpecificSettings.globalEventListeners) {
          for (const currentGlobalEventListenerName of this.typeSpecificSettings.globalEventListeners) {
            // 2. register all
            GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.registerListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
            this.registeredGlobalEventListenerNames.push(currentGlobalEventListenerName);
          }
        }

        forkJoin([
          google.maps.importLibrary('maps'),
          google.maps.importLibrary('marker')
        ]).subscribe(([
                        loadedMapsLib,
                        loadedMarkerLib
                      ]): void => {
              const {Map} = loadedMapsLib as google.maps.MapsLibrary;
              const {AdvancedMarkerElement} = loadedMarkerLib as google.maps.MarkerLibrary;

              const mapInst = new Map(this.$refs.gmapsWrapper, {
                center: ((typeSpecificSettings) => {
                  let result: google.maps.LatLng | null | google.maps.LatLngLiteral = null;

                  if (typeSpecificSettings.initialCenter && typeSpecificSettings.initialCenter.lat !== undefined && typeSpecificSettings.initialCenter.lng !== undefined) {
                    result = {
                      lat: typeSpecificSettings.initialCenter.lat,
                      lng: typeSpecificSettings.initialCenter.lng
                    };
                  }

                  return result;
                })(this.typeSpecificSettings),
                zoom: ((typeSpecificSettings) => {
                  let result: number | null = null;

                  if (typeSpecificSettings.initialZoom !== undefined) {
                    result = typeSpecificSettings.initialZoom;
                  }

                  return result;
                })(this.typeSpecificSettings),
                mapId: ((typeSpecificSettings) => {
                  let result: string | null = null;

                  if (typeSpecificSettings.mapId !== undefined) {
                    result = typeSpecificSettings.mapId;
                  }

                  return result;
                })(this.typeSpecificSettings),
              });
              for (const currentCircle of this.typeSpecificSettings.circles || []) {
                // tslint:disable-next-line:no-unused-expression
                const createdCircle = new google.maps.Circle({
                  radius: ((circleDef) => {
                    let result: number | null = null;

                    if (circleDef.radius !== undefined) {
                      result = circleDef.radius;
                    }

                    return result;
                  })(currentCircle),
                  center: ((circleDef) => {
                    let result: google.maps.LatLng | google.maps.LatLngLiteral | null = null;

                    if (circleDef.center && circleDef.center.lat !== undefined && circleDef.center.lng !== undefined) {
                      result = {
                        lat: circleDef.center.lat,
                        lng: circleDef.center.lng,
                      };
                    }

                    return result;
                  })(currentCircle),
                  strokeColor: ((circleDef) => {
                    let result: string | null = null;

                    if (circleDef.strokeColor !== undefined) {
                      result = circleDef.strokeColor;
                    }

                    return result;
                  })(currentCircle),
                  strokeOpacity: ((circleDef) => {
                    let result: number | null = null;

                    if (circleDef.strokeOpacity !== undefined) {
                      result = circleDef.strokeOpacity;
                    }

                    return result;
                  })(currentCircle),
                  strokeWeight: ((circleDef) => {
                    let result: number | null = null;

                    if (circleDef.strokeWeight !== undefined) {
                      result = circleDef.strokeWeight;
                    }

                    return result;
                  })(currentCircle),
                  fillColor: ((circleDef) => {
                    let result: string | null = null;

                    if (circleDef.fillColor !== undefined) {
                      result = circleDef.fillColor;
                    }

                    return result;
                  })(currentCircle),
                  fillOpacity: ((circleDef) => {
                    let result: number | null = null;

                    if (circleDef.fillOpacity !== undefined) {
                      result = circleDef.fillOpacity;
                    }

                    return result;
                  })(currentCircle),
                  map: mapInst
                });
                this.circles.push({
                      circle: createdCircle,
                      radius: createdCircle.getRadius()
                    }
                );
              }

              const allMarkers: {
                [key: number]: {
                  instance: google.maps.marker.AdvancedMarkerElement,
                  config: DisguiseDto.GMapsMarker,
                  service?: MarkerService<any>
                }
              } = {};
              for (const currentMarker of this.typeSpecificSettings.markers || []) {
                let markerImpl: MarkerService<DisguiseDto.IGMapsMarkerContent> | undefined;
                if (currentMarker.content) {
                  markerImpl = GMAPS_MARKER_REGISTRY[currentMarker.content['@type']];
                }
                const markerInstance = new AdvancedMarkerElement({
                  position: ((markerDef) => {
                    let result: google.maps.LatLng | google.maps.LatLngLiteral | null = null;

                    if (markerDef.position && markerDef.position.lat !== undefined && markerDef.position.lng !== undefined) {
                      result = {
                        lat: markerDef.position.lat,
                        lng: markerDef.position.lng,
                      };
                    }

                    return result;
                  })(currentMarker),
                  title: ((markerDef) => {
                    let result: string | null = null;

                    if (markerDef.title !== undefined) {
                      result = markerDef.title;
                    }

                    return result;
                  })(currentMarker),
                  content: ((markerDef) => {
                    let result: Node | null = null;

                    if (markerImpl && markerDef.content) {
                      result = markerImpl.generateMarkerContent(markerDef.content);
                    }

                    return result;
                  })(currentMarker),
                  map: mapInst,
                  gmpClickable: true,
                });

                if (markerImpl) {
                  const markerImplRef = markerImpl;
                  const markerInstanceRef = markerInstance;
                  markerInstance.addListener('click', () => {
                    const allOtherMarkerInstances = [];
                    for (const currentMarkerEntry of Object.values(this.allMarkers)) {
                      allOtherMarkerInstances.push(currentMarkerEntry.instance);
                    }
                    markerImplRef.onClick(currentMarker, markerInstanceRef, allOtherMarkerInstances, mapInst);
                  });
                  allMarkers[currentMarker.id || 0] = {
                    instance: markerInstance,
                    config: currentMarker,
                    service: markerImpl
                  };
                } else {
                  allMarkers[currentMarker.id || 0] = {
                    instance: markerInstance,
                    config: currentMarker,
                  };
                }
              }
              this.allMarkers = allMarkers;

              for (const currentLine of this.typeSpecificSettings.polylines || []) {
                const newPolyline = new google.maps.Polyline({
                  path: ((currentMarker) => {
                    let result: google.maps.MVCArray<google.maps.LatLng>
                        | Array<(google.maps.LatLng | google.maps.LatLngLiteral)>
                        | null = null;

                    if (currentMarker && currentMarker.path) {
                      result = [];

                      for (const currentPath of currentMarker.path) {
                        if (currentPath.lat !== undefined && currentPath.lng !== undefined) {
                          result.push({
                            lat: currentPath.lat,
                            lng: currentPath.lng
                          });
                        }
                      }
                    }

                    return result;
                  })(currentLine),
                  geodesic: currentLine.geodesic,
                  strokeColor: ((lineDef) => {
                    let result: string | null = null;

                    if (lineDef.strokeColor !== undefined) {
                      result = lineDef.strokeColor;
                    }

                    return result;
                  })(currentLine),
                  strokeOpacity: ((lineDef) => {
                    let result: number | null = null;

                    if (lineDef.strokeOpacity !== undefined) {
                      result = lineDef.strokeOpacity;
                    }

                    return result;
                  })(currentLine),
                  strokeWeight: ((lineDef) => {
                    let result: number | null = null;

                    if (lineDef.strokeWeight !== undefined) {
                      result = lineDef.strokeWeight;
                    }

                    return result;
                  })(currentLine),
                  map: mapInst,
                  icons: ((lineDef) => {
                    let results: google.maps.IconSequence[] | null = null;
                    if (lineDef.iconSequence !== undefined) {
                      results = [];
                      for (let iconIdx = 0; iconIdx < lineDef.iconSequence.length; iconIdx++) {
                        const currentIcon = lineDef.iconSequence[iconIdx];
                        results.push({
                          icon: ((iconDef) => {
                            let result: google.maps.Symbol | null = null;

                            if (iconDef.icon) {
                              switch (iconDef.icon['@type']) {
                                case 'GMapsSymbolPath': {
                                  const castedIcon = iconDef.icon as DisguiseDto.GMapsSymbolPathGMapsPolylineIcon;
                                  if (castedIcon.path) {
                                    switch (castedIcon.path) {
                                      case 'BACKWARD_CLOSED_ARROW': {
                                        result = {
                                          path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                                        };
                                        break;
                                      }
                                      case 'BACKWARD_OPEN_ARROW': {
                                        result = {
                                          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
                                        };
                                        break;
                                      }
                                      case 'FORWARD_CLOSED_ARROW': {
                                        result = {
                                          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
                                        };
                                        break;
                                      }
                                      case 'FORWARD_OPEN_ARROW': {
                                        result = {
                                          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
                                        };
                                        break;
                                      }
                                      case 'CIRCLE': {
                                        result = {
                                          path: google.maps.SymbolPath.CIRCLE
                                        };
                                        break;
                                      }
                                    }
                                  }
                                  if (result) {
                                    result = {
                                      ...result,
                                      fillColor: ((fillColorDef) => {
                                        let fillColorResult: string | null = null;

                                        if (fillColorDef.fillColor !== undefined) {
                                          fillColorResult = fillColorDef.fillColor;
                                        }

                                        return fillColorResult;
                                      })(castedIcon),
                                      fillOpacity: ((fillOpacityDef) => {
                                        let fillOpacityResult: number | null = null;

                                        if (fillOpacityDef.fillOpacity !== undefined) {
                                          fillOpacityResult = fillOpacityDef.fillOpacity;
                                        }

                                        return fillOpacityResult;
                                      })(castedIcon),
                                      scale: ((scaleDef) => {
                                        let scaleResult: number | null = null;

                                        if (scaleDef.scale !== undefined) {
                                          scaleResult = scaleDef.scale;
                                        }

                                        return scaleResult;
                                      })(castedIcon),
                                      strokeColor: ((strokeColorDef) => {
                                        let strokeColorResult: string | null = null;

                                        if (strokeColorDef.strokeColor !== undefined) {
                                          strokeColorResult = strokeColorDef.strokeColor;
                                        }

                                        return strokeColorResult;
                                      })(castedIcon),
                                      strokeOpacity: ((strokeOpacityDef) => {
                                        let strokeOpacityResult: number | null = null;

                                        if (strokeOpacityDef.strokeOpacity !== undefined) {
                                          strokeOpacityResult = strokeOpacityDef.strokeOpacity;
                                        }

                                        return strokeOpacityResult;
                                      })(castedIcon),
                                      strokeWeight: ((strokeWeightDef) => {
                                        let strokeWeightResult: number | null = null;

                                        if (strokeWeightDef.strokeWeight !== undefined) {
                                          strokeWeightResult = strokeWeightDef.strokeWeight;
                                        }

                                        return strokeWeightResult;
                                      })(castedIcon),
                                    };
                                  }

                                  break;
                                }
                              }
                            }

                            return result;
                          })(currentIcon),
                          fixedRotation: currentIcon.fixedRotation,
                          offset: currentIcon.offset,
                          repeat: currentIcon.repeat,
                        });

                        if (currentIcon.functions) {
                          for (const currentFunction of currentIcon.functions) {
                            switch (currentFunction['@type']) {
                              case 'Move': {
                                let count = 0;
                                const maxStepsOrDefault = currentFunction.maxSteps || 200;
                                const stepOrDefault = currentFunction.step || 1;
                                const waitMsOrDefault = currentFunction.waitMs || 20;
                                window.setInterval(() => {
                                  if (newPolyline) {
                                    count = (count + stepOrDefault) % maxStepsOrDefault;
                                    const icons = newPolyline.get('icons');
                                    icons[iconIdx].offset = count / (maxStepsOrDefault / 100) + '%';
                                    newPolyline.set('icons', icons);
                                  }
                                }, waitMsOrDefault);
                                break;
                              }
                            }
                          }
                        }
                      }
                    }
                    return results;
                  })(currentLine)
                });
              }

              this.mapInst = mapInst;
              this.initialZoom = mapInst.getZoom() as number;
              this.mapInst.addListener('zoom_changed', this.dynamicallyUpdateCircles);
            }
        );
      }).catch((error) => {
        if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
          this.$store.commit('showSnack', {
            message: 'Google Maps API nicht verfügbar',
            color: 'error'
          });
        }
      });
    }).catch((error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'GMaps API Key konnte nicht geladen werden.',
          color: 'error'
        });
      }
    });
  }

  dynamicallyUpdateCircles() {
    const zoom = (this?.mapInst?.getZoom() || 0);
    if (zoom === 0) {
      return;
    }

    const scaleFactor = Math.pow(2, this.initialZoom - (zoom || 0));

    this.circles.forEach((val: {circle: google.maps.Circle, radius: number}) => {
      val.circle.setRadius(val.radius * scaleFactor);
    });
  }

  destroyed() {
    if (this.registeredGlobalEventListenerNames) {
      for (const currentGlobalEventListenerName of this.registeredGlobalEventListenerNames) {
        GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.detachListener(currentGlobalEventListenerName, this.globalEventListenerTriggeredCb);
      }
    }
  }

  private globalEventListenerTriggeredCb(eventData: any) {
    if (eventData) {
      const eventType = eventData['@type'];
      if (eventType) {
        switch (eventType) {
          case 'GMapsUserRequestedMarkerDetailsDto': {
            const castedType = eventData as DisguiseDto.GMapsUserRequestedMarkerDetailsDto;

            const marker = this.allMarkers[castedType.markerId || 0];

            if (marker.service && this.mapInst) {
              const allOtherMarkerInstances = [];
              for (const currentMarkerEntry of Object.values(this.allMarkers)) {
                allOtherMarkerInstances.push(currentMarkerEntry.instance);
              }
              marker.service.onUserRequestedDetails(marker.config, marker.instance, allOtherMarkerInstances, this.mapInst);
            }

            break;
          }
        }
      }
    }
  }
}

